import { expose } from 'comlink';

let expirationTimeout: number | undefined;

function clearExpirationTimeout() {
  clearTimeout(expirationTimeout);
  expirationTimeout = undefined;
}

function setExpirationTimeout(timeToExpire: number, callback: () => void) {
  if (expirationTimeout) {
    clearExpirationTimeout();
  }
  expirationTimeout = setTimeout(callback, timeToExpire);
  return expirationTimeout;
}

const exports = {
  setExpirationTimeout,
  clearExpirationTimeout,
};

export type SessionWorker = typeof exports;

expose(exports);
